import React, { createRef, FC, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { FormInstance } from 'antd/es/form/Form'
import { RadioChangeEvent, Skeleton } from 'antd'
import {
    Button, Collapse, Form, Input, Space, List, Typography, Spin, notification, Table,
    Popover, Row, Col, Card, ConfigProvider, Radio, Tabs
} from 'antd'
import { DeleteOutlined, CheckCircleOutlined, DownloadOutlined } from '@ant-design/icons'
import zhCN from 'antd/es/locale/zh_CN'
import moment from 'moment'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { IAppState } from '@/store/reducers'
import { getWorkgroup } from '@/store/actions/tableEdit.action'
import type { Descendant } from 'slate'
import DSlate, { DefaultPlugin } from '@dslate/dslate'
import type { DSlateRef } from '@dslate/core'
import { ConfigProvider as DslateConfigProvider, defaultConfig } from '@dslate/core'
import { downloadFile, getUuid, hideLoading, showLoading } from '@/utils/util'
import { handleTrim, serialize } from '@/pages/table2Mana/table2Edit'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import {
    addOnlineReviewTMT, getFile, getLeaderForWorkgroup, getOnlineReviewById, getOnlineReviewTMT, getUserWorkGroup, itmtDictatorship,
    relevant, relevantGetById
} from '@/services/progress.service'
import { IAddOnlineReviewData, IAddRelevant, IFileRes } from '@/store/models/process.model'
import type { IUserInfo } from '@/store/models/auth.model'
import type { IWorkgroupObj } from '@/store/models/tableEdit.model'
import SelectUser from '@/components/selectUser'
import { RoleCont } from '@/store/constant/auth.constant'
import Nav from '@/components/nav'

interface IUserList {
    id: number | undefined
    judgesType: number | null
    tmtMail: string
    tmtUser: string
    nickName: string
    login: string
    workGroupId: number
}

const plugs = { ...DefaultPlugin }
// 删除图片工具
Reflect.deleteProperty(plugs, 'ImgPlugin')

const SelectRelativeReview: FC = () => {
    const history = useHistory()
    const locationObj = useLocation()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const locationSearch = useRef<any>({})
    const formRef = createRef<FormInstance>()
    const formRef2 = createRef<FormInstance>()
    const [form] = Form.useForm()
    // 富文本编辑器
    const editorRef = useRef<DSlateRef>(null)
    const editorRef2 = useRef<DSlateRef>(null)
    const editorRef3 = useRef<DSlateRef>(null)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const { Panel } = Collapse
    const { Text } = Typography

    const [collapseValue, setCollapseValue] = useState<string[] | string>(['1', '2'])
    const [showSelectUser, setShowSelectUser] = useState(false)
    const [popUpSelectUser, setPopUpSelectUser] = useState<null|number>(null)
    const [enableWorkgroupLs, setEnableWorkgroupLs] = useState<IWorkgroupObj[]>([])
    // 富文本编辑器key
    // 提案申请相关性反馈
    const [editorKey, setEditorKey] = useState<string>('1')
    // 评审内容
    const [editorKey2, setEditorKey2] = useState<string>('2')
    const [switchKey, setSwitchKey] = useState(['3', '4', '5', '6'])
    // 流程状态 0 申请  1 相关性  2 选择 TMT  3 TMT 反馈
    // const [processState, setProcessState] = useState(0)
    // 是否勾选相关性
    // const [isSelectRelevant, setIsSelectRelevant] = useState<number | undefined>()
    const [userLs, setUserLs] = useState<any[]>([])
    const [userBackLs, setUserBackLs] = useState<IUserList[]>([]) // 备份读取出来的人员列表
    const [loading, setLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)
    // 查看信息
    const [formObj, setFormObj] = useState<(IAddOnlineReviewData) & {id: number, creator: string, files: IFileRes[]} | null>(null)
    // 回显反馈
    const [formObjFeed, setFormObjFeed] = useState<any>(null)
    // 已反馈用户列表
    const [feedbackList, setFeedbackList] = useState<any[]>([])
    // 是否已反馈过
    const [feeded, setFeeded] = useState(false)
    const [isItmtLeader, setIsItmtLeader] = useState(false)
    const [isOverDue, setIsOverDue] = useState(false)
    // 记录是否参与
    const [isParticipate, setIsParticipate] = useState<boolean | null>(null)
    // 是否独裁
    const [dictatorship, setDictatorship] = useState(false)
    const [selectWorkgroup, setSelectWorkgroup] = useState<string | undefined>()
    // 富文本编辑器 内容
    // 提案申请相关性反馈
    const [descriptionValue, setDescriptionValue] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    // 评审内容
    const [descriptionValue2, setDescriptionValue2] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    // 独裁
    const [descriptionValue3, setDescriptionValue3] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 15 },
    }
    const tailLayout = {
        wrapperCol: { offset: 6, span: 15 },
    }
    const approvalType = [
        { id: 1, label: t('technicalPlan') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 2, label: t('technicalDefineAndResearchTaskBook') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 3, label: t('technicalAchievementDelivery') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 4, label: t('buTMTApproveTech') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
    ]
    // const findLabel = (arr: any[], id: number) =>
    //     arr.find(((item: any) => item.id === id))?.label ?? ''
    
    // const technologicalLeadershipArr = useRef([{
    //     label: t('leadership'),
    //     id: 1
    // },
    // // {
    // //     label: t('homeleadership'),
    // //     id: 4
    // // },
    // {
    //     label: t('equalize'),
    //     id: 2
    // }, {
    //     label: t('trail'),
    //     id: 3
    // }])
    // const technicalContributionArr = useRef([{
    //     label: t('innovationSellingPoint'),
    //     id: 1
    // }, {
    //     label: t('keySellingPoint'),
    //     id: 2
    // }, {
    //     label: t('secondarySellingPoints'),
    //     id: 3
    // }, {
    //     label: t('basicTechnology'),
    //     id: 4
    // }])
    // const labelArr = [t('core') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
    //     t('key') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
    //     t('basicTechnology'),
    //     t('reserveTechnology'),
    // ]
    const [columns, setColumns] = useState([
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'creatorName',
            key: 'creatorName',
            width: 150,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('isRelevant')}</span>,
            dataIndex: 'isRelevant',
            key: 'isRelevant',
            width: 100,
            ellipsis: { showTitle: true },
            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
            render (value: boolean, record: any) {
                if (record.auditOrNot) {
                    return <span>{t('sitInOn')}</span>
                } else {
                    if (value !== null) {
                        if (value) {
                            return <span>{t('Yes')}</span>
                        }
                        return <span>{t('No')}</span>
                    } else {
                        return <></>
                    }
                }
            }
        },
        {
            title: () => <span>{t('wcYOCuH76At1ckcMdzKKf')}</span>,
            dataIndex: 'judgesType',
            key: 'judgesType',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number | null) {
                if(value === 1){
                    return <span>{t('T33AqK8KbZMESLZl4j41q')}</span>
                }else if(value === 2){
                    return <span>{t('XyU0VPlblKWVpW6SokzAQ')}</span>
                }else{
                    return <></>
                }
            }
        },
        // {
        //     title: () => <span>{t('technologicalLeadership')}</span>,
        //     dataIndex: 'technologyLeadership',
        //     key: 'technologyLeadership',
        //     width: 100,
        //     ellipsis: { showTitle: true },
        //     render (value: number, record: any) {
        //         return (record.isPL === 0 && formObj?.reviewType === 4)
        //             ? '' : findLabel(technologicalLeadershipArr.current, value)
        //     }
        // },
        // {
        //     title: () => <span>{t('technicalContribution')}</span>,
        //     dataIndex: 'technologyContribution',
        //     key: 'technologyContribution',
        //     width: 100,
        //     ellipsis: { showTitle: true },
        //     render (value: number, record: any) {
        //         return (record.isPL === 0 && formObj?.reviewType === 4)
        //             ? '' : findLabel(technicalContributionArr.current, value)
        //     }
        // },
        // {
        //     title: () => <span>{t('techType')}</span>,
        //     dataIndex: 'coreTechnology',
        //     key: 'coreTechnology',
        //     width: 100,
        //     ellipsis: { showTitle: true },
        //     render (value: number, record: any) {
        //         return (record.isPL === 0 && formObj?.reviewType === 4) ? '' : labelArr[value]
        //     }
        // },
        {
            title: () => <span>{t('tmtUser')}</span>,
            dataIndex: 'tmtInfos',
            key: 'tmtInfos',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any[]) {
                return value.map(item => item.tmtFullUser).join(',')
            }
        },
        {
            title: () => <span>{t('description')}</span>,
            dataIndex: 'description',
            key: 'description',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: string) {
                return <Popover 
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ])
    const tmtColumns = [
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'tmtFullUser',
            key: 'tmtFullUser',
            width: 150,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('isParticipate')}</span>,
            dataIndex: 'isParticipate',
            key: 'isParticipate',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: boolean | null, record: any) {
                if (record.isRelevant) {
                    return <span>{t('join')}</span>
                } else if (record.auditOrNot) {
                    return <span>{t('sitInOn')}</span>
                } else {
                    return <span>{t('notAdd')}</span>
                }
            }
        },
        {
            title: () => <span>{t('isPassed')}</span>,
            dataIndex: 'isPassed',
            key: 'isPassed',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: boolean | null) {
                if (value !== null) {
                    if (value) {
                        return <span>是</span>
                    } else {
                        return <span>否</span>
                    }
                } else {
                    return <></>
                }
            }
        },
        {
            title: () => <span>{t('wcYOCuH76At1ckcMdzKKf')}</span>,
            dataIndex: 'judgesType',
            key: 'judgesType',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number | null) {
                if(value === 1){
                    return <span>{t('T33AqK8KbZMESLZl4j41q')}</span>
                }else if(value === 2){
                    return <span>{t('XyU0VPlblKWVpW6SokzAQ')}</span>
                }else{
                    return <></>
                }
            }
        },
        {
            title: () => <span>{t('tmtMail')}</span>,
            dataIndex: 'tmtMail',
            key: 'tmtMail',
            width: 150,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('reviewContent')}</span>,
            dataIndex: 'reviewContent',
            key: 'reviewContent',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: string) {
                return <Popover 
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ]

    // 提案申请相关性反馈
    const onFinish = async (values: any) => {
        const editorHtmlValue = editorRef.current?.serialize({ children: serialize(handleTrim(descriptionValue)) })
        const formData = {
            ...values,
            workGroupId: Number(values.workGroupId),
            description: JSON.stringify({
                str: editorHtmlValue || '',
                obj: handleTrim(descriptionValue)
            }),
        }
        if (values.auditOrNot === 1) {
            formData.isRelevant = true
            Reflect.deleteProperty(formData, 'auditOrNot')
        } else if (values.auditOrNot === 2){
            formData.auditOrNot = true
        } else if (values.auditOrNot === 3){
            formData.isRelevant = false
            Reflect.deleteProperty(formData, 'auditOrNot')
        } else {
            formData.auditOrNot = false
        }
        console.log('onFinish: ', values, formData)
        try {
            setLoading(true)
            // const flag = true
            // if (flag) {
            //     console.log('locationkey: ', locationObj.key)
            //     return
            // }
            // 独裁
            if (dictatorship) {
                if (userInfo) {
                    const editorHtmlValue3 = editorRef3.current?.serialize({ children: serialize(handleTrim(descriptionValue3)) })
                    await itmtDictatorship({
                        id: undefined,
                        isPassed: values.isPassed === 1,
                        reviewContent: JSON.stringify({
                            str: editorHtmlValue3 || '',
                            obj: handleTrim(descriptionValue3)
                        }),
                        techOnlineReviewId: values.techOnlineReviewId,
                        tmtFullUser: userInfo.nickName,
                        tmtMail: userInfo.email,
                        tmtUser: userInfo.login
                    })
                }
            } else if (!locationSearch.current.isWrite) {
                // 如果是选择相关性状态，则保存人员信息
                const onlineReviewUserInfo: IAddRelevant[] = userLs.map(item => ({
                    id: item.id,
                    // description: formData.description,
                    techOnlineReviewId: values.techOnlineReviewId,
                    tmtMail: item.tmtMail,
                    tmtUser: item.tmtUser,
                    tmtFullUser: item.nickName,
                    judgesType: item.judgesType
                }))
                // 提交相关性反馈
                // 是不是模拟账户登录
                let isAdmin = false
                if(userInfo?.simulation){
                    isAdmin = true
                }
                await relevant({
                    ...formData,
                    tmts: onlineReviewUserInfo
                },isAdmin).finally(() => {
                    setLoading(false)
                })
            } else {
                // 如果是填写状态，则保存填写反馈信息
                const editorHtmlValue2 = editorRef2.current?.serialize({ children: serialize(handleTrim(descriptionValue2)) })
                await addOnlineReviewTMT({
                    techOnlineReviewId: values.techOnlineReviewId,
                    isParticipate: typeof values.isParticipate === 'number' ? values.isParticipate === 1 : values.isParticipate,
                    isPassed: typeof values.isPassed === 'number' ? values.isPassed === 1 : undefined,
                    reviewContent: JSON.stringify({
                        str: editorHtmlValue2 || '',
                        obj: handleTrim(descriptionValue2)
                    }),
                }).finally(() => {
                    setLoading(false)
                })
            }
            const args = {
                message: t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'),
                description: '',
                icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
                duration: 3,
            }
            notification.open(args)
            if (locationObj.key) {
                history.goBack()
            } else {
                history.replace('/techReviewProgress')
            }
        } catch (error: any) {
            setLoading(false)
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        console.log('onFinishFailed: ', errorFields)
    }
    const onChangeCollapse = (e: string[] | string) => {
        setCollapseValue(e)
    }
    const onSelectRelevant = (e: RadioChangeEvent) => {
        // setIsSelectRelevant(e.target.value)
        console.log('onSelectRelevant: ', e.target.value)
        setUserLs([])
    }
    const selectUserCallback = ({ users: selUsers, workGroupId }: {users: Array<IUserInfo & {workGroupId?: number}>, workGroupId?: number}) => {
        console.log('selUsers: ', selUsers, workGroupId)
        if (selectWorkgroup) {
            formRef.current?.setFieldValue('workGroupId', selectWorkgroup)
        }
        formRef.current?.setFieldValue('selectTmtUser', 111)
        formRef.current?.validateFields(['selectTmtUser'])
        const addLs: IUserList[] = []
        const _userLs = [...userLs]
        selUsers.forEach(item => {
            const findIndex = _userLs.findIndex(user => user.login === item.login && user.workGroupId === Number(selectWorkgroup))
            if (findIndex !== -1) {
                addLs.push({
                    ..._userLs[findIndex],
                    workGroupId: Number(selectWorkgroup)
                })
                _userLs.splice(findIndex, 1)
            } else {
                const findObjOld = userBackLs.find(user => user.login === item.login && user.workGroupId === Number(selectWorkgroup))
                // 找出原来已经加过的人，保留id
                if (findObjOld) {
                    if(findObjOld.judgesType !== popUpSelectUser) {
                        addLs.push({ 
                            ...findObjOld,
                            judgesType: popUpSelectUser,
                            workGroupId: Number(selectWorkgroup)
                        })
                    }else{
                        addLs.push(findObjOld)
                    }
                } else {
                    addLs.push({
                        id: undefined,
                        tmtMail: item.email,
                        tmtUser: item.login,
                        nickName: item.nickName,
                        login: item.login,
                        judgesType: popUpSelectUser,
                        workGroupId: Number(selectWorkgroup)
                    })
                }
            }
        })
        // 选中人员再与原选择列表合并 并剔重
        const unionArr = _userLs.concat(addLs)
        setUserLs(unionArr)
        if (popUpSelectUser === 1) {
            formRef.current?.validateFields(['tmts'])
        }
    }

    // 查看提案申请信息
    const getViewDetail = async (id: string) => {
        try {
            showLoading(<Spin size='large' />)
            const res = await getOnlineReviewById(+id).finally(() => {
                hideLoading()
            })
            setLoaded(true)
            if (!res) return
            setFormObj({
                id: res.id,
                version: res.version,
                fileIds: res.files.map(item => item.id),
                workGroupId: res.workGroup?.id,
                crossBreedWorkGroupName: res.crossBreedWorkGroup?.workGroupName ?? '',
                roadMap: res.roadMap,
                proposalName: res.proposalName,
                subsidiary: res.subsidiary,
                reviewDate: moment(res.reviewDate),
                reviewDateHours: res.reviewDateHours,
                isDisruptive: res.isDisruptive,
                disruptiveReview: res.disruptiveReview,
                isCross: res.isCross,
                isCrossReview: res.isCrossReview,
                techLevel: res.techLevel,
                description: res.description,
                creator: res.creator || '',
                costBuss: res.costBuss ? res.costBuss.map((item: any) => item.bu) : [],
                dutyBuss: res.dutyBuss ? res.dutyBuss.map((item: any) => item.bu) : [],
                reviewType:res.reviewType,
                tmtReviewDueDate: moment(res.tmtReviewDueDate).format('YYYY-MM-DD'),
                files: res.files
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    // 页面显示相关性内容
    const loadRevantData = (findObj: any, id: string | null) => {
        // 是否相关
        // 如果找到自己的记录，则为已反馈
        // if(userInfo?.simulation ){
        //     setFeeded(false)
        // }else{
        //     setFeeded(true)
        // }
        let auditOrNot: number | null
        if (findObj.isRelevant === null) {
            if(findObj.auditOrNot){
                auditOrNot = 2
            }else{
                auditOrNot = 3
            }
        } else if (findObj.isRelevant) {
            auditOrNot = 1
        } else if (findObj.isRelevant === false) {
            auditOrNot = 3
        } else {
            auditOrNot = null
        }
        if(selectWorkgroup === '9999'){
            auditOrNot = 1
            setFeeded(true)
        }
        setFormObjFeed({
            techOnlineReviewId: id,
            isRelevant: findObj.isRelevant ? 1 : 2,
            description: findObj.description || '',
            selectTmtUser: findObj.tmtInfos,
            auditOrNot
        })
        // setIsSelectRelevant(findObj.isRelevant ? 1 : 2)
        // setIsSelectRelevant(auditOrNot ? auditOrNot : 0)
        if (findObj.description) {
            const descriptionObj = JSON.parse(findObj.description)
            setDescriptionValue(descriptionObj.obj)
            setEditorKey(getUuid(8))
        }
        const userLsRes = findObj.tmtInfos.map((item: any) => ({
            id: item.id,
            tmtMail: item.tmtMail,
            tmtUser: item.tmtUser,
            nickName: item.tmtFullUser,
            login: item.tmtUser,
            judgesType: item.judgesType,
            workGroupId: item.workGroup ? item.workGroup.id : 9999
        }))
        console.log('userLsRes: ', userLsRes)
        setUserLs(userLsRes.slice(0))
        setUserBackLs(userLsRes.slice(0))
        setSwitchKey([getUuid(8), switchKey[1], switchKey[2], switchKey[3]])
        console.log('------switchKey-----',switchKey)
    }

    const checkLeader = async () => {
        const res = await getUserWorkGroup({
            login: userInfo?.login || '',
            orgRole: RoleCont.ITMTLEADER
        })
        if (res && res.length > 0) {
            setIsItmtLeader(true)
        } else {
            setIsItmtLeader(false)
        }
    }

    const getFeedbackLs = async (id: string) => {
        try {
            const workGroupRes = await getLeaderForWorkgroup()
            let workGroupId = '9999'
            if(workGroupRes && workGroupRes.length > 0){
                workGroupId = workGroupRes[0].id
            }
            setSelectWorkgroup(String(workGroupId))
            const res = await relevantGetById(+id)
            setFeedbackList(res)
            // 找出自己填的记录，并回显
            if (userInfo) {
                // isParticipate === null 表示还未反馈
                // const findObj = res.find(item => item.creator === userInfo.login && (item.workGroup ? item.workGroup.id === workGroupId : '9999' === workGroupId))
                const findObj = res.find(item =>  (item.workGroup ? item.workGroup.id === workGroupId : '9999' === workGroupId))
                if (findObj) {
                    loadRevantData(findObj,id)
                }else{
                    setFeeded(false)
                }
                if(workGroupId === '9999'){
                    const userInfoTsp = await getUserWorkGroup({
                        login: userInfo?.login || '',
                        orgRole: RoleCont.TSP
                    })
                    const userInfoPrg = await getUserWorkGroup({
                        login: userInfo?.login || '',
                        orgRole: RoleCont.PRG
                    })
                    if((userInfoTsp && userInfoTsp.length > 0) || (userInfoPrg && userInfoPrg.length > 0)){
                        // setIsSelectRelevant(1)
                        setFeeded(true)
                        setFormObjFeed({
                            auditOrNot:1
                        })
                    }
                }
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const getFeedbackTMTLs = async (id: string, isDictatorship: boolean) => {
        try {
            const res = await getOnlineReviewTMT(+id)
            setFeedbackList(res)
            // 找出自己填的记录，并回显
            console.log('tmt反馈列表: ', res)
            // 找出自己填的记录，并回显
            if (userInfo) {
                // isParticipate !== null 已反馈过
                const findObj = res.find(item => item.isParticipate !== null && item.tmtUser === userInfo.login)
                console.log('findObj: ', findObj)
                if (findObj) {
                    // 设为已反馈
                    setFeeded(true)
                    // 独裁
                    if (isDictatorship) {
                        if (findObj.reviewContent) {
                            const descriptionObj = JSON.parse(findObj.reviewContent)
                            setDescriptionValue3(descriptionObj?.obj)
                        }
                        formRef.current?.setFieldsValue({
                            isPassed: findObj.isPassed ? 1 : 2,
                            reviewContent: findObj.reviewContent || ''
                        })
                        setFormObjFeed({
                            isPassed: findObj.isPassed ? 1 : 2,
                            reviewContent: findObj.reviewContent || ''
                        })
                        setSwitchKey([switchKey[0], switchKey[1], switchKey[2], getUuid(8)])
                    } else {
                        // setIsSelectRelevant(findObj.isRelevant ? 1 : 2)
                        if (findObj.reviewContent) {
                            const descriptionObj = JSON.parse(findObj.reviewContent)
                            setDescriptionValue2(descriptionObj.obj)
                            setEditorKey2(getUuid(8))
                        }
                        const _isParticipate = findObj.isParticipate !== null ? (findObj.isParticipate ? 1 : 2) : findObj.isParticipate
                        const _isPassed = findObj.isPassed ? 1 : 2
                        const _techOnlineReviewId = locationSearch.current.progressId
                        formRef.current?.setFieldsValue({
                            techOnlineReviewId: _techOnlineReviewId,
                            isParticipate: _isParticipate,
                            isPassed: _isPassed,
                            reviewContent: findObj.reviewContent || ''
                        })
                        setFormObjFeed({
                            techOnlineReviewId: _techOnlineReviewId,
                            isParticipate: _isParticipate,
                            isPassed: _isPassed,
                            reviewContent: findObj.reviewContent || ''
                        })
                        setIsParticipate(_isParticipate)
                        setSwitchKey([switchKey[0], getUuid(8), getUuid(8), switchKey[3]])
                    }
                }
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const joinTranslatedStrings = (...strings: string[]) => {
        return strings.join(i18n.language !== 'zh' ? ' ' : '')
    }

    // 获取当前人作为Leader所在的域列表
    const getWorkgroupLs = async () => {
        const res = await getLeaderForWorkgroup()
        console.log('setEnableWorkgroupLs: ', res)
        if(res && res.length > 0){
            setSelectWorkgroup(String(res[0].id))
            setEnableWorkgroupLs(res)
        }else{
            // 设置一个无效的ID，后台来处理逻辑
            setSelectWorkgroup(String(9999))
        }
    }
    const onChangeWorkgroup = (val: string) => {
        setSelectWorkgroup(val)
        formRef.current?.setFieldValue('workGroupId', val)
        // 找出自己填的记录，并回显
        console.log('userInfo: ', userInfo, feedbackList, val)
        if (userInfo) {
            // isParticipate === null 表示还未反馈
            // const findObj = feedbackList.find(item =>  item.creator === userInfo.login && item.workGroup.id === Number(val))
            const findObj = feedbackList.find(item => item.workGroup.id === Number(val))
            if (findObj) {
                const routeParams = new URLSearchParams(location.search)
                const id = routeParams.get('progressId')
                loadRevantData(findObj,id)
            } else {
                setFeeded(false)
                const descriptionObj = [
                    {
                        type: 'paragraph',
                        children: [{ text: '' }],
                    },
                ]
                setDescriptionValue(descriptionObj)
                setEditorKey(getUuid(8))
                setUserLs([])
                setSwitchKey([getUuid(8), switchKey[1], switchKey[2], switchKey[3]])
            }
        }
    }
    
    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techReviewProgress',
            breadcrumbName: t('technicalReviewProcess'),
        },
        {
            path: '/addProgress',
            breadcrumbName: 'ITMT' + (i18n.language !== 'zh' ? ' ' : '') + t('feedback'),
        },
    ])
    useEffect(() => {
        // 获取当前人作为Leader所在的域列表
        getWorkgroupLs()
        checkLeader()
        console.log('locationObj: ', locationObj)
        const routeParams = new URLSearchParams(location.search)
        const progressIdParam = routeParams.get('progressId')
        const isWriteParam = routeParams.get('write')
        const type = routeParams.get('type')
        // 是否独裁
        const isDictatorship = routeParams.get('dictatorship')
        setDictatorship(!!isDictatorship)
        locationSearch.current = {
            progressId: +(progressIdParam || ''),
            isWrite: isWriteParam ? true : undefined,
            isDictatorship: !!isDictatorship
        }
       

        if (type) {
            localStorage.setItem('curTab', type)
        }
        routes[1] = {
            path: '/techReviewProgress',
            breadcrumbName: approvalType[(Number(type) || 1) - 1].label
        }
        if (progressIdParam) {
            getViewDetail(progressIdParam)
            if (!isWriteParam) {
                getFeedbackLs(progressIdParam)
            } else {
                getFeedbackTMTLs(progressIdParam, !!isDictatorship)
                setColumns(tmtColumns)
                const curRoute = {
                    path: '/addProgress',
                    breadcrumbName: 'TMT' + (i18n.language !== 'zh' ? ' ' : '') + t('writeFeedback'),
                }
                if (isDictatorship) {
                    curRoute.breadcrumbName = 'ITMT' + (i18n.language !== 'zh' ? ' ' : '') + t('dictatorship')
                }
                routes.splice(routes.length - 1, 1, curRoute)
            }
            formRef.current?.setFieldValue('techOnlineReviewId', +progressIdParam)
        }
        setRoutes([...routes])
        if (!workgroupList.length) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }
    }, [])
    // 详情
    useEffect(() => {
        if (selectWorkgroup) {
            formRef.current?.setFieldValue('workGroupId', selectWorkgroup)
            // 如果是主域，强制参与
            console.log('--------如果是主域，强制参与--------',formObj?.workGroupId,selectWorkgroup)
            if (String(formObj?.workGroupId) === selectWorkgroup) {
                setFormObjFeed({ auditOrNot:1 })
                setFeeded(true)
            }
        }
    }, [selectWorkgroup])
    useEffect(() => {
        if (formObj) {
            formRef2.current?.setFieldsValue(formObj)
            // 判断评审时间是否大于当前日期
            if(formObj?.tmtReviewDueDate){
                const now = moment().format('YYYY-MM-DD')
                if(formObj?.tmtReviewDueDate >= now){
                    setIsOverDue(true)
                }
            }
            // 如果是主域，强制参与
            if (String(formObj?.workGroupId) === selectWorkgroup) {
                setFormObjFeed({ auditOrNot:1 })
                setFeeded(true)
            }
        }
    }, [formObj])
    // 回显反馈
    useEffect(() => {
        if (formObjFeed && formRef.current) {
            formRef.current?.setFieldsValue(formObjFeed)
        }
    }, [formObjFeed])
    useEffect(() => {
        // 不设置值验证会报错
        formRef.current?.setFieldValue('description', 111)
    }, [descriptionValue])
    useEffect(() => {
        // 不设置值验证会报错
        formRef.current?.setFieldValue('reviewContent', 111)
        formRef.current?.validateFields(['reviewContent'])
    }, [descriptionValue2])
    useEffect(() => {
        // 不设置值验证会报错
        formRef.current?.setFieldValue('reviewContent', 111)
        formRef.current?.validateFields(['reviewContent'])
    }, [descriptionValue3])

    useEffect(() => {
        // if (userInfo?.simulation || (isItmtLeader && isOverDue)) {
        if ((isItmtLeader && isOverDue)) {
            setFeeded(false)
        } else {
            setFeeded(true)
        }
        // 如果是主域，强制参与
        if (String(formObj?.workGroupId) === selectWorkgroup) {
            setFormObjFeed({ auditOrNot:1 })
            setFeeded(true)
        }
    }, [isOverDue, isItmtLeader])

    const isMainDomain = useMemo(() => {
        return String(formObj?.workGroupId) === selectWorkgroup
    }, [formObj, selectWorkgroup])

    const auditOrNot = Form.useWatch('auditOrNot', form)

    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                dispatch={dispatch}
            />
            <Collapse collapsible="header" className="edit_table"
                style={{ paddingTop: 0 }}
                activeKey={collapseValue}
                onChange={onChangeCollapse}
            >
                <Panel header={!locationSearch.current.isWrite ? t('feedback') : t('writeFeedback')} key="1"
                    forceRender
                    collapsible='disabled'
                >
                    <Row>
                        <Col span={13}>
                            <Tabs type="card"
                                activeKey={selectWorkgroup}
                                className={`select_group select_group2 ${enableWorkgroupLs.length === 0 ? 'no_tabs' : ''}`}
                                onChange={onChangeWorkgroup}
                            >
                                {enableWorkgroupLs.map(enableWorkgroupItem => (<Tabs.TabPane
                                    tab={enableWorkgroupItem.workGroupName}
                                    key={enableWorkgroupItem.id}
                                >
                                </Tabs.TabPane>))}
                            </Tabs>
                            <Form {...layout} 
                                form={form}
                                ref={formRef}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                className='ti_an_detail'
                            >
                                <Form.Item name="techOnlineReviewId" hidden><Input /></Form.Item>
                                <Form.Item name="workGroupId" hidden><Input /></Form.Item>
                                {/* 选择相关性 */}
                                {!locationSearch.current.isWrite && (
                                    <>
                                        <Form.Item name='auditOrNot'
                                            label={<span className='label'>{t('auditOrNot')}</span>}
                                            // valuePropName="checked"
                                            rules={[
                                                {
                                                    required: true, message: t('auditOrNot Required')
                                                },
                                            ]}
                                        >
                                            {/* <Switch key={switchKey[0]} onChange={onSelectRelevant} defaultChecked={isSelectRelevant} /> */}
                                            <Radio.Group key={switchKey[0]} onChange={onSelectRelevant}>
                                                <Radio value={1}>{t('join')}</Radio>
                                                {
                                                    !isMainDomain && (
                                                        <>
                                                            <Radio value={2}>{t('sitInOn')}</Radio>
                                                            <Radio value={3}>{t('isNotRelevant')}</Radio>
                                                        </>
                                                    )
                                                }
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item name='description'
                                            label={<span className='label'>{t('description')}</span>}
                                        >
                                            <Input hidden />
                                            <DslateConfigProvider
                                                value={{
                                                    ...defaultConfig,
                                                    plugins: [
                                                        ...Object.values({
                                                            ...plugs
                                                        }), 
                                                    ],
                                                }}
                                            >
                                                <DSlate ref={editorRef} key={editorKey} value={descriptionValue} onChange={setDescriptionValue} />
                                            </DslateConfigProvider>
                                        </Form.Item>
                                    </>)
                                }
                                {/* 选择了相关后需要展示的内容 */}
                                {(auditOrNot === 1 || auditOrNot === 2) &&
                                    // 选择相关成员
                                    !locationSearch.current.isWrite &&
                                    (<>
                                        {auditOrNot === 1 && (<>
                                            <Form.Item name='tmts'
                                                label={<span className='label'>{ t('reviewNameList')}</span>}
                                                rules={[
                                                    {
                                                        required: true,
                                                        validator: async () => {
                                                            if (userLs.filter(item =>item.judgesType === 1).length === 0) {
                                                                const helpStr = t('reviewNameList Required')
                                                                return Promise.reject(new Error(helpStr))
                                                            } else {
                                                                return Promise.resolve()
                                                            }
                                                        }
                                                    }
                                                ]}
                                            >
                                                <Input hidden />
                                                {userLs.filter(userItem => userItem.workGroupId === Number(selectWorkgroup)).length > 0 && (<List style={{ marginBottom: 10, background: '#fff' }}
                                                    bordered
                                                    dataSource={userLs.filter(userItem => userItem.workGroupId === Number(selectWorkgroup))}
                                                    renderItem={(item, index) => {
                                                        if(item.judgesType === 1) {
                                                            return (<List.Item
                                                                key={item.tmtUser}
                                                                actions={[
                                                                    <Text className='txt_red hand' onClick={() => {
                                                                        userLs.splice(index, 1)
                                                                        setUserLs([...userLs])
                                                                        formRef.current?.setFieldValue('tmts', userLs.length ? 111 : '')
                                                                        formRef.current?.validateFields(['tmts'])
                                                                    }} title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                                                ]}
                                                            >{item.nickName}</List.Item>)
                                                        }
                                                    }}
                                                />)}
                                                <Button
                                                    onClick={() => {
                                                        setShowSelectUser(true)
                                                        setPopUpSelectUser(1)
                                                    }}
                                                >{t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + (t('reviewNameList'))}</Button>
                                            </Form.Item>
                                        </>)}
                                        {(auditOrNot === 2) && (<Form.Item name='tmts'
                                            label={<span className='label'>{t('sitInOnList')}</span>}
                                            rules={[
                                                {
                                                    required: auditOrNot === 2 ? true : false,
                                                    validator: async () => {
                                                        if (auditOrNot === 2 && userLs.filter(item =>item.judgesType === 2).length === 0) {
                                                            const helpStr = t('sitInOnList Required')
                                                            return Promise.reject(new Error(helpStr))
                                                        } else {
                                                            return Promise.resolve()
                                                        }
                                                    }
                                                }
                                            ]}
                                        >
                                            <Input hidden />
                                            {userLs.filter(userItem => userItem.workGroupId === Number(selectWorkgroup)).length > 0 && (<List style={{ marginBottom: 10, background: '#fff' }}
                                                bordered
                                                dataSource={userLs.filter(userItem => userItem.workGroupId === Number(selectWorkgroup))}
                                                renderItem={(item, index) => {
                                                    if(item.judgesType === 2) {
                                                        return (<List.Item
                                                            key={item.tmtUser}
                                                            actions={[
                                                                <Text className='txt_red hand' onClick={() => {
                                                                    userLs.splice(index, 1)
                                                                    setUserLs([...userLs])
                                                                    formRef.current?.setFieldValue('tmts', userLs.length ? 111 : '')
                                                                    formRef.current?.validateFields(['tmts'])
                                                                }} title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                                            ]}
                                                        >{item.nickName}</List.Item>)
                                                    }
                                                }}
                                            />)}
                                            <Button
                                                onClick={() => {
                                                    setShowSelectUser(true)
                                                    setPopUpSelectUser(2)
                                                }}
                                            >{t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + (t('sitInOnList'))}</Button>
                                        </Form.Item>
                                        )}
                                    </>)
                                }
                                {locationSearch.current.isWrite && (
                                // TMT 成员填写反馈
                                    <>
                                        <Form.Item name='isParticipate'
                                            label={<span className='label'>{t('isParticipate')}</span>}
                                            // valuePropName="checked"
                                            rules={[
                                                {
                                                    required: true, message: t('isParticipate Required')
                                                },
                                            ]}
                                        >
                                            <Radio.Group key={switchKey[1]} onChange={e => {
                                                console.log('isParticipate: ', e.target)
                                                setIsParticipate(e.target.value === 1)
                                                // formRef.current?.setFieldValue('isPassed', null)
                                                formRef.current?.resetFields(['isPassed'])
                                            }} value={auditOrNot}>
                                                <Radio value={1}>{t('Yes')}</Radio>
                                                <Radio value={2}>{t('No')}</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item name='isPassed'
                                            label={<span className='label'>{t('isPassed')}</span>}
                                            rules={[
                                                {
                                                    required: !!isParticipate, message: t('isPassed Required')
                                                },
                                            ]}
                                        >
                                            <Radio.Group key={switchKey[2]} disabled={!isParticipate}>
                                                <Radio value={1}>{t('Yes')}</Radio>
                                                <Radio value={2}>{t('No')}</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <Form.Item name='reviewContent'
                                            label={<span className='label'>{t('reviewContent')}</span>}
                                            rules={[
                                                {
                                                    required: true
                                                },
                                                {
                                                    validator: async () => {
                                                        if (JSON.stringify(descriptionValue2) === '[{"type":"paragraph","children":[{"text":""}]}]') {
                                                            // eslint-disable-next-line quotes
                                                            const helpStr = t('reviewContent Required')
                                                            return Promise.reject(new Error(helpStr))
                                                        } else {
                                                            // 去掉前后空格
                                                            const editorHtmlValue = editorRef2.current?.serialize({ children: serialize(handleTrim(descriptionValue2)) })
                                                            // 获取去掉html后的纯文本
                                                            const word = editorHtmlValue?.replace(/<[^>]*>/g, '')
                                                            const errorStr = `${t('minLenError')} 10 ${t('lenCharError')}`
                                                            // 如果已反馈，则不用验证
                                                            if (feeded) {
                                                                return Promise.resolve()
                                                            }
                                                            if (word) {
                                                                if (word.length < 10) {
                                                                    return Promise.reject(new Error(errorStr))
                                                                } else {
                                                                    return Promise.resolve()
                                                                }
                                                            } else {
                                                                return Promise.reject(new Error(errorStr))
                                                            }
                                                        }
                                                    }
                                                }
                                            ]}
                                        >
                                            <Input hidden />
                                            {/* {!feeded ?
                                                : <div dangerouslySetInnerHTML={{
                                                    __html: formObjFeed?.reviewContent ? JSON.parse(formObjFeed?.reviewContent).str : ''
                                                }} style={{ wordBreak: 'break-word' }}></div>
                                            } */}
                                            <DslateConfigProvider
                                                value={{
                                                    ...defaultConfig,
                                                    plugins: [
                                                        ...Object.values({
                                                            ...plugs
                                                        }), 
                                                    ],
                                                }}
                                            >
                                                <DSlate ref={editorRef2} key={editorKey2} value={descriptionValue2} onChange={setDescriptionValue2} />
                                            </DslateConfigProvider>
                                        </Form.Item>
                                    </>
                                )}
                                {/* 提交 */}
                                <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                                    <Space size={20}>
                                        {/* itmt 可以修改 */}
                                        {/* {((!locationSearch.current.isWrite)
                                            // 或 tmt 未反馈
                                            || (locationSearch.current.isWrite && !feeded)
                                        ) && */}
                                        <Button type="primary" htmlType="submit" loading={loading}>{t('submit')}</Button>
                                        {/* } */}
                                        {/* <Button htmlType="button" onClick={onReset}>{t('reset')}</Button> */}
                                    </Space>
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col span={11}>
                            <Card title={t('viewInfo')} className='ti_an_detail'>
                                {loaded ?
                                    <Form {...layout} ref={formRef2}>
                                        <Form.Item name='workGroupId'
                                            label={<span className='label'>{t('Work Group')}</span>}
                                        >
                                            {workgroupList.find(workgroup => workgroup.id === formObj?.workGroupId)?.groupName}
                                        </Form.Item>
                                        <Form.Item name='proposalName'
                                            label={<span className='label'>{t('proposalName')}</span>}
                                        >
                                            {formObj?.proposalName}
                                        </Form.Item>
                                        <Form.Item name='reviewDate'
                                            label={<span className='label'>{t('reviewDate')}</span>}
                                        >
                                            {formObj?.reviewDate?.format('YYYY-MM-DD') + ' ' + (formObj?.reviewDateHours || '')}
                                        </Form.Item>
                                        {formObj?.reviewType !== 3 && (
                                            <>
                                                <Form.Item name='costBuss'
                                                    label={<span className='label'>{t('developCostAttribute')}</span>}
                                                >
                                                    <div style={{ wordBreak: 'break-word' }}>
                                                        {formObj?.costBuss?.join(', ')}
                                                    </div>
                                                </Form.Item>
                                                <Form.Item name='dutyBuss'
                                                    label={<span className='label'>{t('developDutySubject')}</span>}
                                                >
                                                    <div style={{ wordBreak: 'break-word' }}>
                                                        {formObj?.dutyBuss?.join(', ')}
                                                    </div>
                                                </Form.Item>
                                            </>
                                        )}
                                        {formObj?.reviewType === 1 && (
                                            <>
                                                <Form.Item name='isDisruptive'
                                                    label={<span className='label'>{t('isApply') + (i18n.language !== 'zh' ? ' ' : '') + t('isDisruptive')}</span>}
                                                >
                                                    {formObj?.isDisruptive ? t('Yes') : t('No')}
                                                </Form.Item>
                                                <Form.Item name='disruptiveReview'
                                                    label={<span className='label'>{t('isDisruptive') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResult')}</span>}
                                                >
                                                    {formObj?.disruptiveReview !== null ? (formObj?.disruptiveReview ? t('Yes') : t('No')) : 'NA'}
                                                </Form.Item>
                                                <Form.Item name='isCross'
                                                    label={<span className='label'>{t('isApply') + (i18n.language !== 'zh' ? ' ' : '') + t('isCross')}</span>}
                                                >
                                                    {formObj?.isCross ? t('Yes') : t('No')}
                                                </Form.Item>
                                                <Form.Item name='isCrossReview'
                                                    label={<span className='label'>{t('isCross') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResult')}</span>}
                                                >
                                                    {formObj?.isCrossReview !== null ? (formObj?.isCrossReview ? t('Yes') : t('No')) : 'NA'}
                                                </Form.Item>
                                                {formObj?.isCross && <Form.Item name='crossBreedWorkGroupId'
                                                    style={{ color: '#FF0000' }}
                                                    label={<span className='label' style={{ color: '#FF0000' }}>{'Crossbreed' + (i18n.language !== 'zh' ? ' ' : '') + t('Work Group')}</span>}
                                                >
                                                    {formObj?.crossBreedWorkGroupName}
                                                </Form.Item>}
                                            </>
                                        )}
                                        <Form.Item name='description'
                                            label={<span className='label'>{(formObj?.reviewType ? approvalType[formObj.reviewType - 1].label : '')
                                                + (i18n.language !== 'zh' ? ' ' : '') + t('description')}</span>}
                                        >
                                            <div dangerouslySetInnerHTML={{
                                                __html: formObj?.description ? JSON.parse(formObj?.description).str : ''
                                            }} style={{ wordBreak: 'break-word' }}></div>
                                        </Form.Item>
                                        <Form.Item name='files'
                                            label={<span className='label'>{t('attach')}</span>}
                                        >
                                            {formObj?.files
                                                ? <List
                                                    itemLayout="horizontal"
                                                    dataSource={formObj?.files}
                                                    renderItem={item => (
                                                        <List.Item className='attach_ls'
                                                            actions={[
                                                                // <Text className='txt_blue hand' title={t('previewFile')} onClick={async () => {
                                                                //     autoClick(`${UploadAPI}/onlinePreview?filePath=${item?.filePath}`)
                                                                // }}><FileSearchOutlined style={{ fontSize: 16 }} /></Text>
                                                            ]}
                                                        >
                                                            <Skeleton avatar title={false} loading={false} active>
                                                                <List.Item.Meta
                                                                    title={<span className='word txt_blue hand'
                                                                        title={item.fileName}
                                                                        onClick={async () => {
                                                                            showLoading(<Spin size='large' />)
                                                                            const res = await getFile(item.id).finally(() => {
                                                                                hideLoading()
                                                                            })
                                                                            downloadFile(res, item.fileName)
                                                                        }}
                                                                    >{item.fileName}<DownloadOutlined className='icon' /></span>}
                                                                />
                                                            </Skeleton>
                                                        </List.Item>
                                                    )}
                                                />
                                                : '无'
                                            }
                                        </Form.Item>
                                    </Form>
                                    : (
                                        <div 
                                            style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                        ><Spin size="large" /></div>
                                    )
                                }
                            </Card>
                        </Col>
                    </Row>
                </Panel>
                {/* 已反馈列表 */}
                <Panel header={(!locationSearch.current.isWrite ? t('ITMT') : t('TMT') ) + (i18n.language !== 'zh' ? ' ' : '') + joinTranslatedStrings(t('feedback'), t('list'))} 
                    key="2"
                >
                    <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                        <Table bordered
                            key={getUuid(8)}
                            dataSource={feedbackList}
                            columns={columns}
                            rowKey="id"
                            pagination={false}
                        ></Table>
                    </ConfigProvider>
                </Panel>
            </Collapse>
            <SelectUser show={showSelectUser} setShow={setShowSelectUser}
                title={t('selectTmtUser')}
                canChangeWorkgroup={false}
                curWorkGroupId={selectWorkgroup}
                enableWorkgroupLs={enableWorkgroupLs}
                confirm={selectUserCallback}
            />
        </Space>
    )
}
export default SelectRelativeReview
